import ComponentManager, {ComponentOptions, ComponentOptionsValuePlaceholder} from "../../componentFramework";
import {NativeJsfAjaxEventStatus, NativeJsfAjaxRequestOptions, NativeJsfAjaxRequestParams} from "../../scripts/jsf/JsfAjax";
import EditContent from "../EditContent";
import JsfJsCommand from "../JsfJsCommand";
import Button from "../Button";
import AjaxStatusScreenBlocker from "../AjaxStatusScreenBlocker";

const defaultOptions = {
	blockScreen: false,
	blockScreenText: ComponentOptionsValuePlaceholder.string.optional,
	actionId: ComponentOptionsValuePlaceholder.string.required,
	dynamicExecutionsSelector: ComponentOptionsValuePlaceholder.string.required,
	render: "@this"
};

export type DefaultOptionsType = typeof defaultOptions;

@ComponentManager.register()
export default class DynamicExecuteButton extends Button {
	public static componentStyleClass = "dynamicExecuteButton";

	private readonly options: ComponentOptions<DefaultOptionsType>;

	constructor(rootElement: HTMLElement) {
		super(rootElement, true);
		this.options = new ComponentOptions(this, rootElement, defaultOptions);
	}

	@ComponentManager.on("ready")
	protected ready() {
		this.addEventListener("click", this.handleClick);
	}

	private handleClick = (event: MouseEvent) => {
		const componentOptions = this.options.getValues();
		const target = event.currentTarget as Element;

		let requestInternalOptions: any;

		if (componentOptions.blockScreen) {
			requestInternalOptions = Object.create(null);
			AjaxStatusScreenBlocker.enableBlockerOnRequest(requestInternalOptions, componentOptions.blockScreenText);
		}

		let identifiers = "";
		const params: any = {};
		document.querySelectorAll(componentOptions.dynamicExecutionsSelector).forEach(value => {
			identifiers = identifiers + " " + value.id;
			params[value.id] = value.id;
		});
		const requestOptions: NativeJsfAjaxRequestOptions = {
			execute: `@this${identifiers}`,
			render: componentOptions.render,
			params: params
		};
		JsfJsCommand.run(
			componentOptions.actionId,
			EditContent.getInstance(target)?.rootElement,
			requestOptions,
			requestInternalOptions,
		);
	}
}
